import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BesprechungRoutingModule } from './besprechung-routing.module';
import { BesprechungViewComponent } from './components/besprechung-view/besprechung-view.component';
import { BesprechungPageComponent } from './pages/besprechung-page/besprechung-page.component';
import { SharedModule } from '../../shared/shared.module';
import { DetailIconListComponent } from './components/detail-icon-list/detail-icon-list.component';
import { QualitiesListComponent } from './components/qualities-list/qualities-list.component';
import { QualityChecklistComponent } from './components/quality-checklist/quality-checklist.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MarkdownModule } from 'ngx-markdown';


@NgModule({
  declarations: [BesprechungViewComponent, BesprechungPageComponent, DetailIconListComponent, QualitiesListComponent, QualityChecklistComponent],
  imports: [
    CommonModule,
    SharedModule,
    BesprechungRoutingModule,
    MatChipsModule,
    MatTooltipModule,
    MarkdownModule
  ]
})
export class BesprechungModule {
}
